import { render } from "./DateFilter.vue?vue&type=template&id=1f3e0b15"
import script from "./DateFilter.vue?vue&type=script&lang=js"
export * from "./DateFilter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/flavianoviana/docker/business-sml/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DateFilter.vue"]])

export default __exports__